import styled from "@emotion/styled"
import { Container } from "@mui/material"

const TextContianer = styled(Container)`
    &&& {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 5vw;
    padding-right: 5vw;
    padding-top: 2vh;
    padding-bottom: 25vh;
    }
`

const AboutMeHeader = styled.span`
    &&& {
        font-weight: bolder;
        font-size: 60pt;
    }
`

const AboutMeText = styled.div`
    &&& {
        padding-top: 2vh;
        font-size: 18pt;
        opacity: 1;
        animation: fadeIn linear 500ms;
    }

    @keyframes fadeIn {
        0% {opacity:0;}
        100% {opacity:1;}
    }
`

const AboutMe: React.FC = () => {
    return (
        <TextContianer>
            <AboutMeHeader>Who Am I?</AboutMeHeader>
            <AboutMeText>
                Hi! Thanks for looking at my website! <b>I'm Sam Jirovec</b>, or as the government referes to me, Samuel Jirovec. I am currently a <b>Full-Stack developer </b>,
                based out of Minneapolis, Minnesota working for the Target Corporation. I've been in the industry for just over two years now and have experience building <b>React/Typescript</b> applications along with the <b>Java-Springboot </b>
                services that back them up.
            </AboutMeText>
            <AboutMeText>
                When I'm not staring at my work computer, I'm probably staring at my personal computer. 
                Don't worry though, I'm most likely socializing over some video games and a good craft brew.
            </AboutMeText>
        </TextContianer>
    )
}

export default AboutMe